import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFilterParams } from '../interfaces/analytic/analytic';
import dayjs from 'dayjs';

interface IAnalyticState {
  filters: IFilterParams,
}

const storedFilters = localStorage.getItem('filters')

export const filterDefault: IFilterParams = {
  from: dayjs().add(-7, 'd').startOf('day').format('YYYY-MM-DD 00:00:00'),
  to: dayjs().format('YYYY-MM-DD 23:59:59'),
  frequency: 'daily',
  orderBy: 'date',
  sort: 'desc',
}

const initialState: IAnalyticState = {
  filters: storedFilters ? JSON.parse(storedFilters) : filterDefault,
};

const analyticSlice = createSlice({
  name: 'analytic',
  initialState,
  reducers: {
    updatedFilters: (state, action: PayloadAction<IFilterParams>) => {
      Object.assign(state.filters, action.payload);
      localStorage.setItem('filters', JSON.stringify(state.filters));
    },
    overwriteFilters: (state, action: PayloadAction<IFilterParams>) => {
      state.filters = action.payload;
      localStorage.setItem('filters', JSON.stringify(state.filters));
    },
    cleanFilters: (state) => {
      state.filters = filterDefault;
    },
  },
});

export const {
  updatedFilters,
  overwriteFilters,
  cleanFilters,
} = analyticSlice.actions;

export default analyticSlice.reducer;
